import {
  IMPORT_ACCOUNTS,
  IMPORT_ACCOUNTS_WITH_ADDING,
  ADD_PERIOD,
  REMOVE_PERIOD,
  EDIT_PERIOD,
  MOVE_PERIOD,
  MAP_ACCOUNTS,
  MAP_ACCOUNTS_TO_GROUPS,
  SET_ACCOUNTS_FILTER,
} from 'constants/actionTypes';

export function importAccounts(data, mapping) {
  return {
    type: IMPORT_ACCOUNTS,
    data,
    mapping,
  };
}

export function importAccountsWithAdding(data, mapping) {
  return {
    type: IMPORT_ACCOUNTS_WITH_ADDING,
    data,
    mapping,
  };
}

export function addPeriod(name, numberOfDays) {
  return {
    type: ADD_PERIOD,
    name,
    numberOfDays,
  };
}

export function removePeriod(periodId) {
  return {
    type: REMOVE_PERIOD,
    periodId,
  };
}

export function editPeriod(periodId, periodObj) {
  return {
    type: EDIT_PERIOD,
    periodId,
    periodObj,
  };
}

export function movePeriod(oldIndex, newIndex) {
  return {
    type: MOVE_PERIOD,
    oldIndex,
    newIndex,
  };
}

export function mapAccounts(caItems) {
  return {
    type: MAP_ACCOUNTS,
    caItems,
  };
}

export function mapAccountsToGroups() {
  return {
    type: MAP_ACCOUNTS_TO_GROUPS,
  };
}

export function setAccountsFilter(filter) {
  return {
    type: SET_ACCOUNTS_FILTER,
    filter,
  };
}
